// extracted by mini-css-extract-plugin
export default {"wrapper":"quote-module--wrapper--g5ZHe","quote":"quote-module--quote--QcEJP","author":"quote-module--author--HAQh5"};